import LoadImg from "../../assets/img/logo-v.png";
import {useContext} from "react";
import {LoadingContext} from "../../contexts";

export const Loading = () => {
  const {loading} = useContext(LoadingContext);
  return (
    <>
      {loading &&
        <div className="loading">
          <img src={LoadImg} className="item" alt="Load"/>
        </div>
      }
    </>
  );
}